/* eslint-disable id-length */
import {PRODUCT, VERSION} from '@/project.config'
import {BaseResponseType, RequestOptionsType} from '@/types/api'
import {TOKEN_KEY} from '@/utils/const'
import axios, {AxiosRequestConfig} from 'axios'
import Cookies from 'js-cookie'
import {getPeriodId} from '@/utils/getPeriodId'
import {useDispatch} from 'react-redux'
import {persistor} from '@/redux'
export default function http<T>(options: RequestOptionsType) {
	const periodId = getPeriodId()
	const token = Cookies.get(TOKEN_KEY)

	const conf: AxiosRequestConfig = {
		...options,
		headers: {
			...options.headers,
			'app-version': VERSION,
			'app-unique': 'teacher.' + (PRODUCT === 'bingo' ? 'efly' : PRODUCT),
			product: 'bingo',
			withCredentials: true,
			v: VERSION,
			'Content-Type': 'application/x-www-form-urlencoded',
			'period-id': periodId
		},
		method: 'POST'
	}

	if (token && conf.headers) {
		conf.headers['author-token'] = token
	}

	return new Promise<T>((resolve, reject) => {
		try {
			axios<BaseResponseType<T>>(conf)
				.then(res => {
					if (res.data.code === 1) {
						resolve(res.data.data)
					}
					if (Number(res.data.code) === 3) {
						// dispatch({type: commAction.SET_TOKEN, payload: ''})
						persistor.purge()
						// dispatch({type: commAction.RESET_COMM_STORE})
						// dispatch({type: homeworkAction.RESET_HOMEWORK_STORE})
						// dispatch({type: userAction.RESET_USER_STORE})
						window.location.replace('/login')
						reject(res.data.message)
					}
					reject(res.data.message)
				})
				.catch(err => {
					reject(err)
				})
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error)
		}
	})
}
